import { create } from 'zustand';

interface UiState {
  coachChatDraft: string;
  setCoachChatDraft: (draft: string) => void;
}

export const useUiStore = create<UiState>((set) => ({
  coachChatDraft: '',
  setCoachChatDraft: (coachChatDraft) => set({ coachChatDraft }),
}));
